const footerLinks = ['Services', 'Work', 'About', 'Contact'];

export default function Footer() {
  return (
    <footer className="py-12 px-6 border-t border-brand-gray">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-8">
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-brand-text">RG Consulting</span>
          <span className="text-xs text-brand-text/40">Robotics, physical AI, and international technical advisory.</span>
        </div>
        <nav className="flex flex-wrap gap-6">
          {footerLinks.map(link => (
            <a key={link} href={`#${link.toLowerCase()}`} className="text-sm text-brand-text/50 hover:text-brand-blue transition-colors">
              {link}
            </a>
          ))}
        </nav>
        <div className="flex flex-col gap-1 text-sm text-brand-text/40">
          <a href="mailto:contact@rgconsulting.com" className="hover:text-brand-blue transition-colors">contact@rgconsulting.com</a>
          <span>© {new Date().getFullYear()} RG Consulting</span>
        </div>
      </div>
    </footer>
  );
}
